import type { PromptDto } from "@/lib/queries";

export interface PromptKpis {
  /** Distinct call sites covered by the listed prompts. */
  callSites: number;
  /** Prompts scoped to a tenant rather than serving as the global fallback. */
  overrides: number;
  total: number;
  inactive: number;
  /** Prompts whose latest version pins no model, so the service default applies. */
  serviceDefault: number;
}

export function summarizePrompts(prompts: PromptDto[]): PromptKpis {
  const callSites = new Set<string>();
  let overrides = 0;
  let inactive = 0;
  let serviceDefault = 0;

  for (const prompt of prompts) {
    callSites.add(prompt.usedIn);
    if (prompt.tenantId) overrides += 1;
    if (prompt.status !== "ACTIVE") inactive += 1;
    if (!prompt.latestVersion?.model) serviceDefault += 1;
  }

  return {
    callSites: callSites.size,
    overrides,
    total: prompts.length,
    inactive,
    serviceDefault,
  };
}
